<template>
  <div id="app">
    <AppMain></AppMain>
  </div>
</template>

<script>
import AppMain from './components/AppMain.vue'

export default {
  name: 'App',
  components: {
    AppMain
  }/*,
  methods: {
    init() {
      if (this._isMobile()) {
        this.getScreen();
      }
    },
    _isMobile() {
      return navigator.userAgent.match(
          /(phone|pod|iPhone|iPod|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
    getScreen() {
      this.$nextTick(() => {
        (function () {
          function resize() {
            let body = document.getElementsByTagName("body")[0];
            let html = document.getElementsByTagName("html")[0];
            let width = html.clientWidth;
            let height = html.clientHeight;
            let max = width > height ? width : height;
            let min = width > height ? height : width;
            body.style.width = max + "px";
            body.style.height = min + "px";
          }
          resize();
          window.addEventListener("resize", resize);
        })();
      });
    }
  },
  mounted() {
    this.init();
  }*/
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  overflow: hidden;
}
#app{
  width: 100%;
  height: 100%;
}
html{
  width: 100vw;
  height: 100vh;

}
body{
  width: 100%;
  height: 100%;
  background: #325f89;
}
/*@media screen and (orientation: portrait) {*/

/*  !*竖屏样式*!*/
/*  body {*/
/*    transform: rotateZ(90deg) translateY(-100%);*/
/*    -webkit-transform: rotateZ(90deg) translateY(-100%);*/
/*    -ms-transform: rotateZ(90deg) translateY(-100%);*/
/*    -webkit-transform-origin: 0 0;*/
/*    transform-origin: 0 0;*/
/*    -ms-transform-origin: 0 0;*/
/*  }*/

/*}*/
</style>
